export interface AmPageDetail {
  pageId?: string,
  pageName?: string,
  domain?: string,
  pageCategory?: string,
  pageStatus?: number,
  publishStatus?: number,
  appealStatus?: number,
  agencyName?: string,
  bmsId?: string,
  pageType?: number,
  pageLang?: string,
  area?: string,
  errMessage?: string,
  createDate?: string,
  createProfileId?: string,
  isDecoration?: number;
  adActive?: number,
  adLimit?: number,
  adAll?: number,
  banningDate?: string,
  appealDate?: string,
  creator?: string,
  operator?: string,
  accounts?: AmAccountName[],
  pages?: AmPageStatus[],
  statusUpdateDate?: string,
  accountIds?: string[],
  relationPageId?: string,
  pageOwner?: string
}

export interface AmAccountName {
  accountId?: string,
  accountName?: string
}

export interface AmPageStatus {
  pageId?: string,
  pageStatus?: number,
  delete?: boolean,
  oldData?: boolean
}

export interface AmPageQuery {
  pageId?: string, //粉丝页ID
  accountId?: string, //账号ID
  domain?: string, //网域
  bmsId?: string, //BMID
  pageStatus?: number, //粉丝页状态
  publishStatus?: number, //发布状态
  appealStatus?: number, //申诉状态
  createDateStart?: string, //主页创建日期  格式 yyyy-MM-dd HH:mm:ss
  createDateEnd?: string,
  appealDateStart?: string,//申诉日期  格式 yyyy-MM-dd HH:mm:ss
  appealDateEnd?: string,
  pageOwner?: string,
  pageNum: number, //页码
  pageSize: number //一页的数据数量
}

export interface DownloadRes {
  uploadNum?: number,
  failNum?: number,
  requestId?: string,
  results?: RowCheck[]
}

export interface RowCheck {
  pageId: string,
  accountId: string,
  message: string
}
export enum ConfigType {
  PageStatus = 'PageStatus',
  PublishStatus = 'PublishStatus',
  AppealStatus = 'AppealStatus',
  PageLanguage = 'PageLanguage',
  PageOwner = 'PageOwner'
}


export default AmPageDetail;
